__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/92f6dcf2e1b1d3977ac5481f00b1394368cec6d7/_next/";